import {useCallback, useState} from 'react';
import { ApiConnector } from "../../common/ApiConnector";

export const useClientesTech = () => {
    const [items, setItems] = useState({
        rubro: '',
        data: [],
        total: 0,
        page: 1,
    });

    const fillItems = useCallback(
        async () => {
            const res = await ApiConnector.get('https://one.quick.com.bo/api/empresas_tech', {
                params: {
                    rubro: items.rubro,
                    page: items.page,
                }
            });

            const { data, current_page, total } = res.data;

            setItems(prev => ({
                ...prev,
                data: data,
                total: total,
                page: current_page,
            }));
        },
        [items]
    );

    return {
        fillItems,
        items,
        setItems,
    }
}
